<template>
  <section class="info-section">
    <div class="info-section__wrapper">
      <!-- Text Section -->
      <div class="info-section__text">
        <h2 class="info-section__title">{{ newsSectionTitle }}</h2>
        <p class="info-section__description">
          {{ newsSectionDescription }}
        </p>
        <a target="_blank" href="https://www.instagram.com/p/DQmQuLxiL8W/" class="font-3">
          {{ newsSectionCta }}</a
        >
      </div>

      <!-- Image Section -->
      <div class="info-section__images">
        <img
          :src="require(`../../assets/img/tasteatlas.jpg`)"
          alt="tasteatlas featured in legendary food places in barcelona"
          class="info-section__image"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "GallerySection",
  computed: {
    newsSectionTitle() {
      return this.getnewsSection().title;
    },
    newsSectionDescription() {
      return this.getnewsSection().description;
    },
    newsSectionCta() {
      return this.getnewsSection().cta;
    }
  },
  methods: {
    getnewsSection() {
      return this.$store.getters.currentData.newsSection;
    }
  }
};
</script>

<style scoped>
.info-section {
  max-width: 1140px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.info-section__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  gap: 2rem;
}

/* Text section */
.info-section__text {
  flex: 1;
  padding-top: 2rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-section__title {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.info-section__description {
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
}

/* Image section */
.info-section__images {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.info-section__image {
  width: 100%;
  object-fit: contain;
}

/* Responsive */
@media (max-width: 768px) {
  .info-section__wrapper {
    flex-direction: column;
  }

  .info-section__text {
    order: -1;
  }

  .info-section__images {
    flex-wrap: wrap;
    justify-content: center;
  }

  .info-section__image {
    width: 100%;
  }
}
</style>
